/**
 * @generated SignedSource<<169f361ddb8e8ebe13052c94210e1af3>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
export type ClientStatus = "ACTIVE" | "ADDED" | "ARCHIVED" | "PENDING" | "%future added value";
import { FragmentRefs } from "relay-runtime";
export type InviteDialog_addedUsers$data = {
  readonly edges: ReadonlyArray<{
    readonly node: {
      readonly client: {
        readonly clientStatus: ClientStatus;
      } | null | undefined;
    } | null | undefined;
  } | null | undefined> | null | undefined;
  readonly totalCount: number;
  readonly " $fragmentSpreads": FragmentRefs<"PendingInvitesList_invites">;
  readonly " $fragmentType": "InviteDialog_addedUsers";
};
export type InviteDialog_addedUsers$key = {
  readonly " $data"?: InviteDialog_addedUsers$data;
  readonly " $fragmentSpreads": FragmentRefs<"InviteDialog_addedUsers">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "InviteDialog_addedUsers",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "totalCount",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "InviteEdge",
      "kind": "LinkedField",
      "name": "edges",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "Invite",
          "kind": "LinkedField",
          "name": "node",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "User",
              "kind": "LinkedField",
              "name": "client",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "clientStatus",
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PendingInvitesList_invites"
    }
  ],
  "type": "InviteConnection",
  "abstractKey": null
};

(node as any).hash = "4d1729eaf40c19dcf989e46ee7203932";

export default node;
